'use client'

import styled$1 from 'styled-components';
export * from 'styled-components';

const defaultStyled = typeof styled$1 === "function" ? styled$1 : styled$1["default"];

export { defaultStyled as default };
//# sourceMappingURL=styled-components.mjs.map
